export const setCache = (key, data) => {
  const payload = {
    data,
    timestamp: Date.now(),
  };

  localStorage.setItem(key, JSON.stringify(payload));
};

export const getCache = (key, maxAgeMs) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const parsed = JSON.parse(raw);

    if (!parsed.timestamp || Date.now() - parsed.timestamp > maxAgeMs) {
      localStorage.removeItem(key);
      return null;
    }

    return parsed.data;
  } catch (err) {
    localStorage.removeItem(key);
    return null;
  }
};

export const clearCache = (key) => {
  localStorage.removeItem(key);
};
